var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.98,
  cy: 12,
  r: 7.98,
  fill: "#fff",
  stroke: "#ccc"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.69 15.44v-2.71h2.71v-1.37h-2.71V8.64h-1.37v2.72h-2.7v1.37h2.7v2.71z",
  fill: "#ef5a5e"
})));

export default SvgIconAdd;